/// <reference types="redux-persist" />
import {configureStore} from '@reduxjs/toolkit'
import storage from 'redux-persist/lib/storage'
import {combineReducers} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import thunk from 'redux-thunk'
import {UserModel} from '../features/auth/models'
import userSliceReducer from './states/user'
import khipuSliceReducer from './states/khipu'
import hoteleriaSliceReducer from './states/hoteleria'
import centralSliceReducer from './states/central'
import lavanderiaSliceReducer from './states/lavanderia'
import recreacionSliceReducer from './states/recreacion'
import limpiezaSliceReducer from './states/limpieza'

import {KhipuModel} from '../models/khipu.model'
import {
  HoteleriaModel,
  CentralModel,
  LavanderiaModel,
  RecreacionModel,
  LimpiezaModel,
} from '../models'

export interface AppStore {
  user: UserModel
  khipu: KhipuModel
  hoteleria: HoteleriaModel
  central: CentralModel
  lavanderia: LavanderiaModel
  recreacion: RecreacionModel
  limpieza: LimpiezaModel
}

const persistConfig = {
  key: 'root',
  storage,
}

const rootReducer = combineReducers({
  user: userSliceReducer,
  khipu: khipuSliceReducer,
  hoteleria: hoteleriaSliceReducer,
  central: centralSliceReducer,
  lavanderia: lavanderiaSliceReducer,
  recreacion: recreacionSliceReducer,
  limpieza: limpiezaSliceReducer,
})

const persistedReducer = persistReducer(persistConfig, rootReducer) as any

export default configureStore<AppStore>({
  reducer: persistedReducer,
  middleware: [thunk],
})
